import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Toolbar, Typography, Box, Container, Grid, Card, CardActionArea, Stack, Button, useMediaQuery, Divider } from '@mui/material';
import ImagePicker from '../../shared/components/image-picker';
import { HubDetailsContext } from '../../shared/context/hub-details';
import HubButtonService from '../../shared/services/hub-buttons-service';
import EastIcon from '@mui/icons-material/East';
import Carousel from 'react-material-ui-carousel';
import gaiaTheme from '../../theme';
import ProjectCarousel from '../components/project-carousel';
import InvestmentProjectService from '../services/investment-project-service';
import useWindowDimensions from '../../shared/hooks/use-window-dimentions';

const HubPage = () => {

  const [buttons, setButtons] = useState();
  const [desktopColumnCount, setDesktopColumnCount] = useState();
  const [buttonTitleTypography, setButtonTitleTypography] = useState('h6');
  const [callToAction, setCallToAction] = useState('');
  const [images, setImages] = useState([]);
  const [activeImage, setActiveImage] = useState(0);
  const [caroselProjects, setCaroselProjects] = useState();

  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  const hub = useContext(HubDetailsContext);
  const hubButtonService = HubButtonService.getInstance();
  const navigate = useNavigate();
  const location = useLocation();
  const investmentProjectService = new InvestmentProjectService();
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    let buttonUserType = undefined;
    // Check if this is a page for a specific role, and if so set this for use in the http call.
    if (location.pathname.indexOf('seller') !== -1) {
      buttonUserType = 'SELLER';
      setCallToAction('View more');
    } else if (location.pathname.indexOf('buyer') !== -1) {
      buttonUserType = 'BUYER';
      setCallToAction('Browse projects');
    } else {
      setCallToAction('View more');
    }



    if (hub.hubDetails) {
      setDesktopColumnCount(12 / hub.hubDetails?.hub_styles.desktop_button_column_count);
      setButtonTitleTypography(hub.hubDetails?.hub_styles.desktop_button_column_count < 3 ? 'h5' : 'h6');
    };

    hubButtonService.getAvailableButtons(false, buttonUserType, true)
      .then(response => {
        if (location.pathname.indexOf('buyer') === -1 && location.pathname.indexOf('seller') === -1) {
          setButtons(response.filter(button => !button.limit_to_user_role));
        } else {
          setButtons(response);
        }

      });
  }, [hub.hubDetails, location.pathname]);

  useEffect(() => {
    if (hub.hubDetails.hub_styles) {
      setImages(hub.hubDetails.hub_styles.hub_home_header_image);
    };

    if (hub.hubDetails.hub_styles.carosel_project_type === 'unit_based') {

      // 
    } else if (hub.hubDetails.hub_styles.carosel_project_type === 'investment') {
      let params = new URLSearchParams();
      params.append('page', 0);
      params.append('size', 18);

      investmentProjectService.getProjects(params.toString())
        .then(response => {
          setCaroselProjects(response.investmentProjects);
        })
        .catch(err => {
          console.error(err.message);
        });
    }
  }, [hub]);

  const handleClick = (button) => {

    if (button.route_is_internal) {
      navigate(button.url);

    } else {
      window.open(button.url, '_self');
    }
  };

  return (<>
    <>
      <Toolbar />
      <Carousel
        height='50vh'
        autoPlay={true}
        animation='flash'
        duration='1000'
        indicators={false}
        index={activeImage}
        onChange={(index) => setActiveImage(index)}
        swipe
        interval={5000}

      >
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt='Cornish landscape'
            //loading="lazy"
            style={{
              height: '50vh',
              minWidth: "100%",
              objectFit: "cover",
              backgroundPosition: "center center",
              // backgroundRepeat: "no-repeat"
            }}
          />
        ))}
      </Carousel>

      <Box sx={{ position: 'absolute', zIndex: 2, height: '50vh', width: '100%', top: isMobileMode ? '56px' : height < 732 ? '12px' : '90px', left: '24px' }}>
        <Container maxWidth="lg" sx={{ mt: 2 }}>
          <Grid container spacing={2} >
            <Grid item xs={12} md={12} lg={12}>
              <Box sx={{
                padding: isMobileMode ? 0 : 6,
                //pl: isMobileMode ? 6 : 0
                pl: 0
              }}>
                <Typography
                  variant="h3"
                  component="h1"
                  textAlign={isMobileMode ? 'center' : 'left'}
                  sx={{ fontWeight: 700, color: hub.hubDetails.hub_styles.title_text_color, mb: 2 }}
                  dangerouslySetInnerHTML={{ __html: hub.hubDetails.hub_styles.title_copy }}
                >
                </Typography>
                <Typography
                  variant="h6"
                  textAlign={isMobileMode ? 'center' : 'left'}
                  sx={{ color: hub.hubDetails.hub_styles.title_text_color, fontWeight: 200 }}
                  dangerouslySetInnerHTML={{ __html: hub.hubDetails.hub_styles.body_copy }}
                >
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box sx={{
        backgroundColor: '#f6f6f6', minHeight: '40vh', zIndex: 3, position: 'relative'
      }}>
        <Container maxWidth="lg" sx={{ pt: 8, pb: 4 }}>
          <Grid container spacing={4} sx={{ marginTop: `${hub.hubDetails.hub_styles.hub_home_button_offset}px` }}>
            {buttons && desktopColumnCount && buttons.map((button, index) => {
              return <Grid key={index} item xs={12} md={desktopColumnCount} lg={desktopColumnCount}>
                <Card variant='outlined' sx={{ borderRadius: '10px', minHeight: '340px', height: '100%' }}>
                  <CardActionArea
                    onClick={() => handleClick(button)}
                    sx={{ p: 6, alignItems: 'center', justifyContent: 'space-between', height: '100%', display: 'flex', flexDirection: 'column' }}
                  >
                    <Box sx={{ width: button.icon_path ? '80px' : '80px', ml: 'auto', mr: 'auto', mb: 2, minHeight: button.icon_path ? '80px' : '90px', maxHeight: '100%' }}>
                      {button.icon_path && <>
                        <img
                          src={button.icon_path}
                          alt=''
                          style={{ width: '100%', visibility: true ? 'visible' : 'hidden', maxHeight: '100%' }}
                        />
                      </>}
                      {!button.icon_path && <ImagePicker image={button.icon_code} />}
                    </Box>
                    <Stack direction={'column'} justifyContent={'space-between'} height={'100%'}>
                      <Box>
                        <Typography
                          variant={buttonTitleTypography}
                          sx={{ textAlign: 'center' }}
                        >
                          <b>{button.title_copy}</b>
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{ textAlign: 'center' }}
                          color="text.secondary"
                        >
                          {button.body_copy}
                        </Typography>
                      </Box>

                      <Button endIcon={<EastIcon />} variant='contained' disableElevation className='removeUppercase' sx={{ mt: 4, ml: 'auto', mr: 'auto', borderRadius: '30px' }}>
                        {callToAction}
                      </Button>
                    </Stack>
                  </CardActionArea>
                </Card>
              </Grid>;
            })}
          </Grid>
        </Container>
      </Box>
      <Container maxWidth="lg">
        <Box sx={{
          paddingBottom: isMobileMode ? 6 : 14,
          paddingTop: isMobileMode ? 6 : 14
        }}>
          <Typography
            variant="h5"
            component="h1"
            textAlign={isMobileMode ? 'center' : 'left'}
            sx={{ fontWeight: 700, mb: 1 }}
            dangerouslySetInnerHTML={{ __html: hub.hubDetails.hub_styles.hub_home_secondary_title }}
          >
          </Typography>
          <Typography
            variant="subtitle"
            textAlign={isMobileMode ? 'center' : 'left'}
            sx={{ mb: 10 }}
            dangerouslySetInnerHTML={{ __html: hub.hubDetails.hub_styles.hub_home_secondary_copy }}
          >
          </Typography>

          {caroselProjects?.length > 0 && <>
            {hub.hubDetails.hub_styles.carosel_project_type === 'unit_based' && <ProjectCarousel projects={caroselProjects} />}
            {hub.hubDetails.hub_styles.carosel_project_type === 'investment' && <ProjectCarousel investmentProjects={caroselProjects} />}
          </>
          }
        </Box>

        {(hub.hubDetails.id === 11 || process.env.REACT_APP_ENVIRONMENT === 'LOCAL') && <Box>
          <Box sx={{
            paddingBottom: isMobileMode ? 6 : 14,
            paddingTop: isMobileMode ? 6 : 6,
            borderTop: '1px solid grey'
          }}>
            <Grid container sx={{ mt: 6 }}>
              <Grid item xs={4} md={4} lg={4} >
                <Typography
                  variant="h4"
                >
                  Our partners
                </Typography>
              </Grid>

              <Grid item xs={8} md={8} lg={8}>
                <Box sx={{ maxWidth: '200px', mb: 6 }}>
                  <img src='https://gaia-marketplace-publicly-available-assets.s3.eu-west-2.amazonaws.com/dev/ne-combined-logo.png' alt='logo' />
                </Box>

                <Typography
                  variant="p"
                  sx={{ maxWidth: '670px', display: 'block', mb: 4 }}
                >
                  The North East Carbon and Nature Marketplace is funded by the LINC Pilot Programme, a Defra initiated programme led by the Environment Agency,
                  and developed through local authorities. The Marketplace is hosted by Net Zero North East England, and the North East Combined Authority.
                  <br></br>
                  <br></br>
                  Net Zero North East England is supported by all of the seven North East local authorities,
                  the North East Combined Authority and the North East Climate Coalition. Private sector
                  business leaders will also join the board.
                </Typography>

                <Box sx={{ maxWidth: '100%' }}>
                  <img src='https://gaia-marketplace-publicly-available-assets.s3.eu-west-2.amazonaws.com/dev/ne-partners-update.png' alt='partners' />
                </Box>

                <Divider sx={{ mb: 8, mt: 8 }}></Divider>

                <Box sx={{ maxWidth: '100%', mb: 4 }}>
                  <img src='https://gaia-marketplace-publicly-available-assets.s3.eu-west-2.amazonaws.com/dev/funded-banner.png' alt='funded' />
                </Box>

                <Typography
                  variant="p"
                  sx={{ maxWidth: '100%', display: 'block', mb: 4, textAlign: 'center' }}
                >
                  This project has been funded by the LINC Pilot Programme
                </Typography>


              </Grid>
            </Grid >
          </Box>
        </Box>}
      </Container>
    </>
  </>
  );
};

export default HubPage;